import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Rx';

import { IMyOptions, IMyDate } from 'mydatepicker';

import { Campaign } from '../../campaigns/campaign.model';
import { Agent } from '../agent.model';
import { AgentService } from '../agent.service';

declare var $: any;

@Component({
 selector: 'wm-agent-edit',
 template: require('./agent-edit.component.html')
})
export class AgentEditComponent implements OnInit, OnChanges {
  @Input() campaign: Campaign;
  @Input() project_id: string;

  @Output() agentAdd = new EventEmitter();

  loading = true;

  agentForm: FormGroup;
  submitted: boolean;
  agent: Agent;

  formErrors = { 'shop_id': '', 'purse_id': '', 'purse': '' };

  validationMessages = {
    'shop_id': { required: 'Не задан ID магазина' },
    'purse_id': { required: 'Не задан ID кошелека или кошелек' },
    'purse': { required: 'Не задан ID кошелека или кошелек' },
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private service: AgentService
  ) { }

  ngOnInit() {
    this.buildForm();
    this.submitted = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.campaign = changes.campaign.currentValue;
  }


  addAgent(form_params): void {
    Object.keys(form_params).forEach((key) => {
      if (!form_params[key]) {
        delete form_params[key];
      }
    });

    this.service.createAgent(this.campaign['id'], form_params).subscribe(result => {
      this.agent = result['agent'];

      this.clearErrors();
      this.buildForm();

      this.agentAdd.emit(this.agent);
      this.loading = false;
    }, err => {
      this.clearErrors();
      this.formErrors['exist'] = err['message'];
    });
  }

  onAgentSubmit(model, valid) {
    if ((
      !this.agentForm.get('purse').errors || !this.agentForm.get('purse_id').errors
    ) && !this.agentForm.get('shop_id').errors) {
      valid = true;
    } else {
      this.validateForm();
    }

    if (valid) {
      this.addAgent(model);
    }
  }

  buildForm() {
    this.agentForm = this.fb.group({
      purse_id: ['', Validators.required],
      shop_id: ['', Validators.required],
      purse: ['', Validators.required]
    });
  }

  clearErrors() {
    for (let field of Object.keys(this.formErrors)) {
      this.formErrors[field] = '';
    }
  }

  validateForm() {
    delete this.formErrors['exist'];

    for (let field of Object.keys(this.formErrors)) {
      this.formErrors[field] = '';
      let input = this.agentForm.get(field);
      if (input.errors) {
        for (let error of Object.keys(input.errors)) {
          this.formErrors[field] = this.validationMessages[field][error];
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/agents/components/agent-edit.component.ts